let observer: IntersectionObserver | null = null

if (import.meta.client && typeof IntersectionObserver !== 'undefined') {
  observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) {
        continue
      }

      entry.target.setAttribute('data-reveal', 'true')
      observer?.unobserve(entry.target)
    }
  }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' })
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('reveal', {
    getSSRProps() {
      return {}
    },
    mounted(el: HTMLElement, binding) {
      if (typeof binding.value === 'number') {
        el.style.setProperty('--reveal-index', String(binding.value))
      }

      if (!observer) {
        el.setAttribute('data-reveal', 'true')
        return
      }

      el.setAttribute('data-reveal', 'false')
      observer.observe(el)
    },
    unmounted(el: HTMLElement) {
      observer?.unobserve(el)
    },
  })
})
